<ng-container *ngComponentOutlet="component$ | async"></ng-container>
